import './AutoSuggestFilterForm.css';
import * as React from 'react';
import { t } from 'i18next';
import Autosuggest from 'react-autosuggest';

const AutoSuggestFilterForm = (label, data) => class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data,
      suggestions: [],
      value: '',
    };
  }

    getSuggestions = (value) => {
      const inputValue = value.trim().toLowerCase();
      const inputLength = inputValue.length;
      if (data) {
        return inputLength === 0 ? []
          : data.filter(
            suggestion => suggestion.name.toLowerCase().slice(0, inputLength) === inputValue,
          ).slice(0, 6);
      }
      return [];
    }

    getSuggestionValue = (suggestion) => {
      const { updateCurrent } = this.props;
      updateCurrent(suggestion.id);
      return suggestion.name;
    }

    renderSuggestion = suggestion => (
      <div>{suggestion.name}</div>
    )

    onChange = (event, { newValue }) => {
      this.setState({
        value: newValue,
      });
    }

    onSuggestionsFetchRequested = ({ value }) => {
      this.setState({
        suggestions: this.getSuggestions(value),
      });
    }

    onSuggestionsClearRequested = () => {
      this.setState({
        suggestions: [],
      });
    }

    onSuggestionSelected = (event, { method }) => {
      if (method !== 'click') {
        const { pushFilter } = this.props;
        pushFilter();
      }
    }

    render() {
      const { value, suggestions } = this.state;
      const inputProps = {
        autoFocus: true,
        onChange: this.onChange,
        placeholder: t(`filters.placeholder.${label}`),
        value,
      };

      return (

        <div className="AutoSuggestFilterForm">
          <Autosuggest suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            onSuggestionSelected={this.onSuggestionSelected}
            inputProps={inputProps}
          />
        </div>

      );
    }
};
export default AutoSuggestFilterForm;
